"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var IntlService_1 = require("./IntlService");
var GlobalizationContext_1 = require("../globalization/GlobalizationContext");
// tslint:disable:max-line-length
/**
 * A React component which provides an internationalization service. Expects a locale string as a property of the component.
 */
var IntlProvider = /** @class */ (function (_super) {
    __extends(IntlProvider, _super);
    function IntlProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns an internationalization service. The method is suitable for overriding when you implement custom internationalization behavior.
     */
    IntlProvider.prototype.getIntlService = function () {
        return new IntlService_1.IntlService(this.props.locale);
    };
    /**
     * @hidden
     */
    IntlProvider.prototype.render = function () {
        var _this = this;
        return (React.createElement(GlobalizationContext_1.GlobalizationContext.Consumer, null, function (glob) { return (React.createElement(GlobalizationContext_1.GlobalizationContext.Provider, { value: __assign({}, glob, { intl: _this.getIntlService() }) }, _this.props.children)); }));
    };
    /**
     * @hidden
     */
    IntlProvider.propTypes = {
        locale: PropTypes.string
    };
    return IntlProvider;
}(React.Component));
exports.default = IntlProvider;
// tslint:enable:max-line-length
//# sourceMappingURL=IntlProvider.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-intl/dist/npm/Intl/IntlProvider.js
// module id = 6604
// module chunks = 0